import React from "react";
import Tilt from "react-parallax-tilt";
import Section from "./Section";
import Reveal from "./Reveal";
import Marquee from "./Marquee";
import { pick } from "../techIcons";
import { skills } from "../data";
import { tech } from "../techIcons";

const ringItems = pick("Go","PostgreSQL","Redis","Kafka","RabbitMQ","Docker","Kubernetes","AWS","GraphQL","MongoDB","Cloudflare","Linux","Twilio","React","Nginx","MySQL");

function Skills() {
  const half = Math.ceil(tech.length / 2);
  return (
    <Section id="skills" title="Technical" accent="Skills">

      <Reveal className="carousel-scene" aria-hidden="true">
        <div className="carousel">
          {ringItems.map(({ name, Icon, color }, i) => (
            <div key={name} className="carousel-item" style={{ "--i": i, "--n": ringItems.length, "--c": color }}>
              <Icon />
              <span>{name}</span>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal className="marquees">
        <Marquee items={tech.slice(0, half)} />
        <Marquee items={tech.slice(half)} reverse />
      </Reveal>

      <div className="tech-grid">
        {tech.map(({ name, Icon, color }, i) => (
          <Reveal key={name} delay={(i % 8) * 50} className="tech-tile-wrap">
            <div className="tech-tile" style={{ "--c": color }}>
              <Icon />
              <span>{name}</span>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="skills-grid">
        {skills.map((g, i) => (
          <Reveal key={g.group} delay={(i % 3) * 100}>
            <Tilt tiltMaxAngleX={6} tiltMaxAngleY={6} glareEnable glareMaxOpacity={0.08} scale={1.02}>
              <div className="card skill-card">
                <h3>{g.group}</h3>
                <div className="chips">
                  {g.items.map((it, j) => (
                    <span key={it} className="chip" style={{ animationDelay: `${j * 60}ms` }}>{it}</span>
                  ))}
                </div>
              </div>
            </Tilt>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

export default Skills;
